"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execute = void 0;
const child_process_1 = require("child_process");
// Executes a subprocess.
// Resolves successfully on exit code 0 with all the info
// available
async function execute(command, args, options) {
    // WARN: Snyk CLI uses an internal proxy configuration that interferes
    // with network requests made by subprocesses. In order to bypass this
    // we reset the relevant environment variables to their defaults that
    // the CLI has cached.
    const env = Object.assign({}, process.env);
    if (typeof process.env.SNYK_SYSTEM_HTTP_PROXY !== 'undefined') {
        env.HTTP_PROXY = process.env.SNYK_SYSTEM_HTTP_PROXY;
    }
    if (typeof process.env.SNYK_SYSTEM_HTTPS_PROXY !== 'undefined') {
        env.HTTPS_PROXY = process.env.SNYK_SYSTEM_HTTPS_PROXY;
    }
    if (typeof process.env.SNYK_SYSTEM_NO_PROXY !== 'undefined') {
        env.NO_PROXY = process.env.SNYK_SYSTEM_NO_PROXY;
    }
    const spawnOptions = {
        env,
        shell: false,
        detached: true, // do not send signals to child processes
    };
    if (options && options.cwd) {
        spawnOptions.cwd = options.cwd;
    }
    const fullCommand = `${command} ${args.join(' ')}`.trim();
    const startTime = Date.now();
    let processId;
    try {
        const worker = (0, child_process_1.spawn)(command, args, spawnOptions);
        processId = worker.pid;
        return await new Promise((resolve, reject) => {
            let stderr = '';
            let stdout = '';
            worker.stdout.on('data', (data) => {
                stdout += data;
            });
            worker.stderr.on('data', (data) => {
                stderr += data;
            });
            worker.on('error', (e) => {
                reject({
                    stderr,
                    stdout,
                    error: e,
                    duration: Date.now() - startTime,
                    command: fullCommand,
                });
            });
            worker.on('exit', (code) => {
                if (code && code > 0) {
                    resolve({
                        stderr,
                        stdout,
                        duration: Date.now() - startTime,
                        command: fullCommand,
                        exitCode: code,
                    });
                }
                else {
                    resolve({
                        stderr,
                        stdout,
                        duration: Date.now() - startTime,
                        command: fullCommand,
                        exitCode: code,
                    });
                }
            });
        });
    }
    finally {
        if (processId) {
            // Additional anti-zombie protection.
            // Process here should be already stopped.
            try {
                process.kill(processId, 'SIGKILL');
            }
            catch (e) {
                // Process already stopped.
            }
        }
    }
}
exports.execute = execute;
//# sourceMappingURL=child-process.js.map